export default "__VITE_ASSET__DXAIlbOQ__"